module.exports = __webpack_public_path__ + "img/art5-img2.9d3bed93.jpeg";